import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
    error: false,
    retract: false,
};
const retractBidReducers = (state = initialState, action) => {
    switch (action.type) {
        case types.RETRACT_BID_REQUESTED:
            return {
                ...state,
                loading: true,
                success: false,
            };
            case types.CLEAR_RETRACT_BID:
                return {
                ...state,
                retract: false,
            };
            case types.RETRACT_BID_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    success: action.payload,
                    error: false,
                    retract: !action.FromMsg ? true : action.FromMsg ,

                    
            }; 

        case types.RETRACT_BID_FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
                retract: false,
            };
           
        
        case types.GET_ONE_USER_SKILLLISTING_REQUESTED:
            return {
                ...state,
                success: false,
                error: false,
                loading: false
            }
        default:
            return state;
    }
};
export default retractBidReducers;
